import React from 'react';

import { tw } from '../../utils/tailwind';
import { Box } from '../Core';
import ICONS from './icons';

interface IIconProps {
  color?: string | undefined;
  icon?: string;
  inlineSVG?: string;
}

const Icon: FCWithClassName<IIconProps> = (props) => {
  const { icon } = props;
  return (
    <Box className={tw('mx-0 my-auto', props.className)}>
      <svg
        viewBox={ICONS[icon]?.viewBox}
        fill="currentColor"
        style={{
          height: 'inherit',
          width: 'inherit',
        }}
      >
        {ICONS[icon]?.circle && <circle {...ICONS[icon]?.circle} />}
        <path d={ICONS[icon]?.path} />
      </svg>
    </Box>
  );
};

export default Icon;
